module.exports = __webpack_public_path__ + "tables/media/Flaticon.90bc8831.ttf";